import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker';

export default class RegNoteBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      job: props.data || null,
      regNote:props.data.reg_note || ""
    };
  }
  handleRegNoteChange(e){
    this.setState({regNote:e.target.value});
  }
  saveRegNoteToJob(){
    this.setState({isLoading:true});
    let that = this;
    $.ajax({
      url: "/api/v1/portal/jobs/save-reg-note/"+that.state.job.id,
      data: {
        api_token: window.api_token,
        reg_note: that.state.regNote
      },
      cache: false,
      method: 'post',
    })
    .done(function() {
      that.setState({isLoading:false});
      that.props.handleHideRegNoteBox();
    });
    
  }
  render() {
    return (
    <div>
      {(this.state.job && this.state.job.id ?
        <div className="job-scheduler-modal reg-note-block">
          <div className="job-scheduler-modal-body">
          <form id={'job-scheduler-note-for-job-'+this.state.job.id} className="text-left">
            <fieldset>
                <h1 className="text-right">Job #{this.state.job.id}</h1>
                <div className="row">
                    <div className="col-md-4 text-right">
                        <h2>Note: </h2>
                    </div>
                    <div className="col-md-4">
                        <textarea name="reg_note"
                            placeholder="Enter Note"
                            className="form-control form-control-lg"
                            defaultValue={this.state.job.reg_note}
                            onChange={(e)=>this.handleRegNoteChange(e)}>
                        </textarea> 
                    </div>
                </div>
                <div className="row">
                  <div className="col-md-5 text-right">
                    <br/>
                    <button className="btn btn-success btn-lg"
                    disabled={(this.state.isLoading) ? true : false}
                    onClick={(e)=>this.saveRegNoteToJob(e)}
                    >Save Note</button>
                  </div>
                </div>
            </fieldset>
          </form>
        </div>
      </div> : null)}
    </div>
    );
  }
}
